import { findKey } from 'lodash';
import { BRAND_ENTITY, SOCIAL_MEDIA_DETAILS_ENTITY } from './constants.js';
import { helpers } from 'vuelidate/lib/validators';

export const startsWithCorrectURL = (stringConst) => (enteredValue) =>
	!helpers.req(enteredValue) ||
	enteredValue.startsWith(stringConst) ||
	enteredValue.startsWith(`https://${stringConst}`);

/** Makes an object from the profile socialMediaDetails array and adds 
	default data for any thing that is missing */
export const makeSocialMediaDetails = (socialMediaDetailItems) => {
	const details = socialMediaDetailItems.reduce((entityObject, item) => {
		entityObject[item.type] = item.value;
		return entityObject;
	}, {});

	return { ...SOCIAL_MEDIA_DETAILS_ENTITY, ...details };
};

/** Makes an object from the profile brand array and adds 
	default data for any thing that is missing */
export const makeBrand = (brandItems) => {
	const brand = brandItems.reduce((entityObject, item) => {
		entityObject[item.name] = item;
		return entityObject;
	}, {});

	return { ...BRAND_ENTITY, ...brand };
};

/** Updates or adds an item to the profile's socialMediaDetails array */
export const updateSocialMediaDetailsArray = (
	{ fieldName, value },
	socialMediaDetailsArray,
) => {
	const updatingItem = socialMediaDetailsArray.find(
		(item) => item.type === fieldName,
	);

	if (updatingItem) {
		updatingItem.value = value;
	} else {
		// Add Item
		socialMediaDetailsArray.push({
			type: fieldName,
			value: value,
		});
	}
};

/** Updates or adds an item to the profile's brand array */
export const updateBrandArray = ({ name, value }, brandArray) => {
	const updatingItem = brandArray.find((item) => item.name === name);

	if (updatingItem) {
		updatingItem.value = value;
	} else {
		// Add Item
		brandArray.push({
			name: name,
			value: value,
		});
	}
};

/** Looks through an array of validations on a Vuelidate model to find the first invalid item */
export const findFirstInvalidItem = (validationList, vuelidateModel) => {
	let invalidItem;
	for (let validation of validationList) {
		invalidItem = findKey(
			vuelidateModel[validation].$params,
			(value, key) => vuelidateModel[validation][key].$invalid,
		);
		if (invalidItem) {
			break;
		}
	}
	return invalidItem ? invalidItem : null;
};

export const splitProfileURL = (url) => {
	let urlSlug = url.split('/').pop(),
		urlPath = url.substring(0, url.lastIndexOf('/') + 1);

	return { urlSlug, urlPath };
};
